import { type Components } from '@webapp/api/integrations/client'
import { IntegrationServicePlatforms } from '@webapp/models/enums'

export const getCurrentNetSuiteEnvironment = (
  existingServiceIntegrations: Components.Schemas.IntegrationResponse[]
) => {
  if (!existingServiceIntegrations) {
    return IntegrationServicePlatforms.MERGE_NETSUITE // Default for new setups
  }

  const existingNativeNetSuiteIntegration = existingServiceIntegrations.find(
    (integration) => integration.name === IntegrationServicePlatforms.NETSUITE
  )

  const existingMergeNetSuiteIntegration = existingServiceIntegrations.find(
    (integration) =>
      integration.name === IntegrationServicePlatforms.MERGE_NETSUITE
  )

  // Similar logic to QB: if no native OR merge exists, prefer Merge
  if (
    !existingNativeNetSuiteIntegration ||
    !!existingMergeNetSuiteIntegration
  ) {
    return IntegrationServicePlatforms.MERGE_NETSUITE
  }

  return IntegrationServicePlatforms.NETSUITE
}
